import { Button } from 'reactstrap';
import TableModal, { RowItem } from '../../../components/modals/TableModal';
import useModalState from '../../../hooks/useModalState';
import { PreQualificationResultRulesResult } from '../models/preQualificationModel';
import { PreQualificationSeverityBadge } from './PreQualificationStatusBadge';
import { PreQualificationResultRuleSeverity } from '../enums/PreQualificationEnum';

interface Props {
  rules_result: PreQualificationResultRulesResult[];
}

const PreQualificationDetailBankRulesModal = ({ rules_result }: Props) => {
  const [showModal, toggleShowModal] = useModalState();
  if (!rules_result || rules_result.length === 0) return null;

  const formatInputs = (inputs?: { [key: string]: any }): string => {
    if (!inputs) return 'N/A';
    return Object.entries(inputs)
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
  };

  const rowsItems: RowItem[] = rules_result.map((rule) => {
    return {
      rows: [
        (rule.rule_digest || rule.rule_key) + ' ' + (rule.value ? '✅' : '❌'),
        <PreQualificationSeverityBadge
          status={rule.severity as PreQualificationResultRuleSeverity}
        />,
        formatInputs(rule.inputs),
        rule.metadata?.formula_used || 'N/A',
      ],
    };
  });

  return (
    <>
      <Button size="sm" color="info" onClick={() => toggleShowModal()}>
        <i className="ni ni-money-coins" />
        <span>Detalle de reglas aplicadas</span>
      </Button>
      <TableModal
        cardHeader={[
          'Regla aplicada',
          'Severidad',
          'Valores de entrada',
          'Fórmula aplicada',
        ]}
        striped
        isOpen={showModal}
        onToggle={toggleShowModal}
        rows={rowsItems}
        title="Detalle de reglas aplicadas"
        size="lg"
      />
    </>
  );
};

export default PreQualificationDetailBankRulesModal;
